import RemoteCall from "../../util/RemoteCall";
let remoteCall = new RemoteCall("/api/noAuth/dingding");
let remoteCall2 =  new RemoteCall("/api/noAuth/dingding/auth/v2");
function getConfigWithoutExceptionHandleAsync(param) {
    return remoteCall._invoke("getConfig", param);
}

function noLoginWithoutExceptionHandleAsync(param) {
    return remoteCall._invoke("/auth/noLogin", param);
}

function qrLoginInfoWithoutExceptionHandleAsync(param) {
    return remoteCall._invoke("qrLoginInfo", param);
}


function qrLoginAsync(arg) {
    return remoteCall.get("qrLogin", arg);
}

function v2NoLoginAsync(arg) {
    return remoteCall2.invoke("noLogin", arg);
}



export default {
    getConfigWithoutExceptionHandleAsync,
    noLoginWithoutExceptionHandleAsync,
    qrLoginInfoWithoutExceptionHandleAsync,
    v2NoLoginAsync,
    qrLoginAsync,
}
